import Report from "../../../report";
import ReportMyReports_Settings from "./settings";
import {ReportConfig} from "../../../@types";
import {ViewType} from "../../../../../gd/const/views/view-type";
import ApiMyTime from "../../../../../gd/api/time-reports/my-time";
import SavedView from "../../../../saved-view/saved-view";
import ApiView from "../../../../../gd/api/view";


export default class ReportMyReports extends Report<ReportMyReports_Settings>{


    constructor(data: ReportConfig) {
        data.type = ViewType.REPORT_MY_REPORTS
        super(data);

        this.icon        = "isvg-time-my-reports"
        // this.description = "Personal time tracking reports."
        this.description = "Displays all your logged hours across projects for quick review."

        this.settings    = new ReportMyReports_Settings(data.settings)
    }

    static initFromSavedView(savedView: SavedView): ReportMyReports {
        return new ReportMyReports(savedView.toReportConfig());
    }

    //Xotel dobavit po vishe. No tut raznie settings. Instance budet otlichatsya
    async getView(){
        try{
            const response = await ApiView.getView(this.id).promise()

            this.savedView = SavedView.initFromJson(response)
            //Set settings from saved view.
            this.settings  = new ReportMyReports_Settings(this.savedView.data.settings)
        }
        catch(e){
            console.error(e)
        }
    }

    async loadData():Promise<any> {
        return await ApiMyTime.customReport(this.settings.daterange.start, this.settings.daterange.end, gd.session.me.id, this.settings.taskTypeIds).promise()
    }

}
